import React from 'react';
import Helmet from "react-helmet";
import {useSelector} from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import { Route, Switch, Redirect } from "react-router-dom";
import Profiletabs from './profileForms/ProfileTabs';
import AccountDetails from "./profileForms/AccountDetails";
import General from "./profileForms/General";
import ConnectAccount from "components/pages/connect-account";

const useStyles = makeStyles(theme => ({
  profile: {
    flexGrow: 1
  }
}));

const Profile = () => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);
  return (
    <div className={classes.profile}>
      <Helmet title="Profile" />
      <Profiletabs />
      <Switch>
        <Route path="/profile/account" component={AccountDetails} />
        <Route path="/profile/general" render={() => <General user={user}/>} />
        <Route path="/profile/payment" render={() => <ConnectAccount user={user}/>} />
        <Redirect from="/profile" to="/profile/account" />
      </Switch>
    </div>
  );
};

export default Profile;
